import { Flex, Text } from '@chakra-ui/react';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, OutlineCard } from '@morressier/alembic';
import { IGetSubmissionRejectionResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import MultilineText from 'src/components/MultilineText';
import { formatDate } from 'src/utils/date';
import { EditorialAttachments } from './EditorialAttachments.js';

export const RejectFeedback = ({
  data,
  dateEntered,
  submissionContextId
}: {
  data: IGetSubmissionRejectionResponse;
  dateEntered: string;
  submissionContextId: string;
}) => {
  const { rejectionReason, attachments, editorComment } = data || {};

  return (
    <OutlineCard padding={4} width="100%">
      <Flex flexDirection="column" gap={6}>
        <Banner variant="alert" heading="Submission Rejected" />

        <Flex flexDirection="column" gap={2}>
          <Flex flexDirection="row" gap={2} alignItems="center">
            <FontAwesomeIcon icon={faCalendar} />
            Received {formatDate(new Date(dateEntered))}
          </Flex>
        </Flex>

        <Flex gap={2} flexDirection={'column'}>
          <Text textStyle="headingGroup">Rejection Reason</Text>
          <Text textStyle="textBody">{rejectionReason}</Text>
        </Flex>

        {editorComment && (
          <Flex gap={2} flexDirection={'column'}>
            <Text textStyle="headingGroup">Editor’s Response</Text>
            <MultilineText textStyle="textBody" text={editorComment} />
          </Flex>
        )}

        <EditorialAttachments attachments={attachments} submissionContextId={submissionContextId} />
      </Flex>
    </OutlineCard>
  );
};
